import React, { useState } from "react";
import { CloseSettingsButton, SettingsMenuWrapper } from "../fieldvision.style";
import { ButtonShapes } from "@mlb/react-patterns/components/Button/button.types";
import ButtonGroup from "@mlb/react-patterns/components/ButtonGroup/buttonGroup";
import { UserOptionPreset } from "../../../util/user-options";
import Icon from "@mlb/react-patterns/components/Icon/icon";
import { IconSizes } from "@mlb/react-patterns/components/Icon/icon.types";
import { QUALITY_CONFIG, SPEED_CONFIG } from "../../FieldVisionController";

interface SettingsMenuProps {
  speed: number;
  visualQualityPreset: UserOptionPreset;
  setPlaybackSpeed(speed: number): void;
  setVisualQualityPreset(quality: UserOptionPreset): void;
  setIsSettingsMenuOpen(isOpen: boolean): void;
}

const qualityButtonConfig = QUALITY_CONFIG.map(
  (quality: { label: string; value: UserOptionPreset }) => {
    return {
      label: quality.label,
      value: quality.value,
      hasHover: true,
      shape: ButtonShapes.SOLID,
    };
  }
);

const speedButtonConfig = SPEED_CONFIG.map(
  (speed: { label: string; value: number }) => {
    return {
      label: speed.label,
      value: speed.value,
      hasHover: true,
      shape: ButtonShapes.SOLID,
    };
  }
);

const SettingsMenu = (props: SettingsMenuProps) => {
  const {
    speed,
    visualQualityPreset,
    setPlaybackSpeed,
    setVisualQualityPreset,
    setIsSettingsMenuOpen,
  } = props;

  const getSelectedPlaybackSpeedButtonIndex = (
    currentPlaybackSpeed: number
  ): number => {
    return SPEED_CONFIG.findIndex(
      (speed) => speed.value === currentPlaybackSpeed
    );
  };

  const getSelectedVisualQualityButtonIndex = (
    currentQualityPreset: UserOptionPreset
  ): number => {
    switch (currentQualityPreset) {
      case "high":
        return 1;
      default:
        return 0;
    }
  };

  return (
    <SettingsMenuWrapper>
      <div style={{ textAlign: "center" }}>Settings</div>
      <div>Visual Quality</div>
      <ButtonGroup
        handlers={{
          onClick: (e: {
            selected: number[];
            changes: {
              value: UserOptionPreset;
            };
          }) => {
            setVisualQualityPreset(e.changes.value);
            setIsSettingsMenuOpen(false);
          },
        }}
        data={[...qualityButtonConfig]}
        selected={getSelectedVisualQualityButtonIndex(visualQualityPreset)}
      />
      <div>Playback Speed</div>
      <ButtonGroup
        handlers={{
          onClick: (e: {
            selected: number[];
            changes: {
              value: number;
            };
          }) => {
            setPlaybackSpeed(e.changes.value);
            setIsSettingsMenuOpen(false);
          },
        }}
        data={[...speedButtonConfig]}
        selected={getSelectedPlaybackSpeedButtonIndex(speed)}
      />
      <CloseSettingsButton
        onClick={() => {
          setIsSettingsMenuOpen(false);
        }}
      >
        <Icon
          className="settings-close-button"
          name="close"
          size={IconSizes.MD}
          fill="#fff"
        />
      </CloseSettingsButton>
    </SettingsMenuWrapper>
  );
};

export default SettingsMenu;
